/* PrivacyAppCard — one inert card per app for privacy mode.
 *
 * Token usage mirrors the .groupName / .groupCount / .groupHeader rules in
 * SidePanelNotificationList.module.css so the card looks visually consistent
 * with group headers (same surface, border, text colors, radius, spacing). */

.card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-8);
  padding: var(--spacing-8) var(--spacing-12);
  /* No margin — the host list (`.privacyList`) supplies inter-card rhythm
   * via its flex `gap`, matching how `.list` spaces notification cards. */
  margin: 0;
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-8);
  /* Same surface as Notification cards (--bg-secondary) for visual
   * consistency; group headers have no background so they float above. */
  background: var(--bg-secondary);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  min-width: 0;
}

/* Mirrors .groupName: semibold weight, secondary text color.
 * 13px literal — no 13px token exists (--text-size-xs=12, --text-size-s=14);
 * same pattern used throughout this package. */
.name {
  font-size: 13px;
  font-weight: var(--text-weight-semibold);
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Tertiary color matches the muted metadata style used across
 * notification cards (timestamps, secondary copy). */
.count {
  font-size: var(--text-size-xs);
  color: var(--text-tertiary);
}
